module.exports = __webpack_public_path__ + "img/icons8-close.27c48c5d.svg";